import { useEffect } from "react";
import { useAnimation } from "../hooks/useAnimation";
import { NavLink } from "react-router-dom";

const NotFound = () => {
  const animate = useAnimation();

  useEffect(() => {
    animate();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="notfound-ctr d-flex justify-content-center align-items-center"
      style={{ minHeight: "90vh" }}
    >
      <div className="text-center">
        <img
          src="/images/404.png"
          alt="Not Found"
          className="container-fluid mt-4"
          style={{ width: "90%", height: "90%", maxWidth: "600px" }}
        />

        <div
          className="mb-5 mt-3 px-5"
          data-animation="fadeIn"
          data-animation-delay="100ms"
        >
          <h2
            style={{
              color: "var(--primary-gray)",
              fontWeight: 900,
              marginBottom: "1rem",
              fontSize: "clamp(3rem, 3vw, 4em)",
            }}
          >
            Ops! Sayfa Bulunamadı
          </h2>
          <p style={{ color: "var(--secondary-gray)", fontSize: "1.1rem" }}>
            Aradığınız sayfa kaldırılmış, adı değiştirilmiş veya geçici olarak
            kullanılamıyor olabilir
          </p>
        </div>

        <div data-animation="slideInUp" data-animation-delay="150ms">
          <NavLink
            to="/"
            className="btn px-5 py-3"
            style={{
              borderRadius: "50px",
              backgroundColor: "var(--secondary-pink)",
              border: "none",
              color: "var(--white)",
              fontSize: "16px",
              fontWeight: "600",
              textDecoration: "none",
              transition: "all 0.3s ease",
              boxShadow: "0px 8px 25px rgba(253, 63, 158, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0px 12px 35px rgba(253, 63, 158, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0px 8px 25px rgba(253, 63, 158, 0.3)";
            }}
          >
            Ana Sayfaya Dön
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
